import { getters } from "@/constants/state";

export default {
  [getters.SCENARIO_SHIFTS_DATE_SCENARIO_SHIFTS_GETTER]: (state) =>
    state.dateScenarioShifts,
};
